import React, { Component } from 'react';
import { Link } from 'gatsby';

import { Icon } from 'elements';
import {
  classnames,
  classname
} from 'utils';
import { GetCategory } from 'query';

import './Nav.css';

class Nav extends Component {
  cl = classname('nav');

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.navHide);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.navHide);
  }

  onBtnClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });

    this.navHeightSet();
  };

  navHeightSet() {
    const navWrapper = document.querySelector('.nav__list-wrapper');
    const navHeight = document.querySelector('.nav__list').offsetHeight;

    navWrapper.style.height = `${navHeight}px`;
  }

  navHide({ target }) {
    if (!this.nav) return;

    if (target !== this.nav && !this.nav.contains(target)) {
      this.setState({
        isOpen: false
      });
    }
  }

  render() {
    const { className, data, id } = this.props;
    const { isOpen } = this.state;

    const classes = classnames(className, this.cl({ open: isOpen }));

    let active = data.filter(item => item.id === id);

    active = active.length > 0 ? active[0] : null;

    return (
      <div className={classes} ref={node => (this.nav = node)}>
        {active && (
          <div className={this.cl('header')} onClick={() => this.onBtnClick()}>
            {active.title}
            <Icon className={this.cl('arrow')} name={'arrow'}/>
          </div>
        )}
        <div className={this.cl('list-wrapper')}>
          <ul className={this.cl('list')}>
            {
              data.map(({ title, uri }) => (
                <li className={this.cl('item')} key={title}>
                  <Link
                    to={uri}
                    className={this.cl('link')}
                    onClick={() =>
                      this.setState({
                        isOpen: false
                      })
                    }
                  >
                    {title}
                  </Link>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  }
}

export default props => <GetCategory>{data => <Nav data={data} {...props} />}</GetCategory>;
